var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1090"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1090"
    },
    "bundlingPackage": "payments-ui-app",
    "bundlingPackageVersion": "static-1.26818",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};